var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.7082 9.34788L25.6519 7.29163L17.4998 15.4437L9.34775 7.29163L7.2915 9.34788L15.4436 17.5L7.2915 25.652L9.34775 27.7083L17.4998 19.5562L25.6519 27.7083L27.7082 25.652L19.5561 17.5L27.7082 9.34788Z"}));
}

Close.defaultProps = {"width":"35","height":"35","viewBox":"0 0 35 35"};

module.exports = Close;

Close.default = Close;
